import { render, staticRenderFns } from "./FlagCard.vue?vue&type=template&id=a28189ea&"
import script from "./FlagCard.vue?vue&type=script&lang=js&"
export * from "./FlagCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports